// tslint:disable
/**
 * Firmabil lekeplass API
 * A description of the API
 *
 * OpenAPI spec version: v0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    AdminSubmission,
    AdminSubmissionFromJSON,
    AdminSubmissionToJSON,
} from './';

/**
 * AdminSubmissionList media type (default view)
 * @export
 * @interface AdminSubmissionList
 */
export interface AdminSubmissionList {
    /**
     * 
     * @type {Array<AdminSubmission>}
     * @memberof AdminSubmissionList
     */
    submissions?: Array<AdminSubmission>;
}

export function AdminSubmissionListFromJSON(json: any): AdminSubmissionList {
    return {
        'submissions': !exists(json, 'submissions') ? undefined : (json['submissions'] as Array<any>).map(AdminSubmissionFromJSON),
    };
}

export function AdminSubmissionListToJSON(value?: AdminSubmissionList): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'submissions': value.submissions === undefined ? undefined : (value.submissions as Array<any>).map(AdminSubmissionToJSON),
    };
}


